const categories = [
  {
    name: 'Person',
    icon: 'user',
    specificOptions: [
      {
        label: 'Gender',
        type: 'select',
        options: ['Male', 'Female', 'Non-binary', 'Other'],
      },
      {
        label: 'Age Group',
        type: 'select',
        options: ['Child', 'Teenager', 'Young Adult', 'Adult', 'Elderly'],
      },
      {
        label: 'Body Type',
        type: 'select',
        options: ['Slim', 'Athletic', 'Average', 'Curvy', 'Muscular', 'Plus-size'],
      },
      {
        label: 'Height',
        type: 'select',
        options: ['Short', 'Average', 'Tall'],
      },
      {
        label: 'Hair Color',
        type: 'color',
      },
      {
        label: 'Skin Tone',
        type: 'color',
      },
      {
        label: 'Expression',
        type: 'emoji',
        emojis: ['😀', '😊', '🙂', '😐', '😢', '😠', '😎', '😍', '🤔', '😴'],
      },
      {
        label: 'Clothing Style',
        type: 'select',
        options: [
          'Casual',
          'Formal',
          'Sporty',
          'Elegant',
          'Fantasy',
          'Business',
          'Vintage',
        ],
      },
    ],
  },

  {
    name: 'Animal',
    icon: 'paw',
    specificOptions: [
      {
        label: 'Species',
        type: 'text',
      },
      {
        label: 'Pose/Action',
        type: 'select',
        options: [
          'Standing',
          'Running',
          'Sleeping',
          'Playing',
          'Flying',
          'Swimming',
          'Jumping',
        ],
      },
    ],
  },

  {
    name: 'Car',
    icon: 'car-side',
    specificOptions: [
      {
        label: 'Type',
        type: 'select',
        options: [
          'Sports Car',
          'SUV',
          'Sedan',
          'Truck',
          'Vintage',
          'Futuristic',
          'Muscle',
        ],
      },
      {
        label: 'Brand (optional)',
        type: 'text',
      },
    ],
  },

  {
    name: 'Landscape',
    icon: 'mountain-sun',
    specificOptions: [
      {
        label: 'Environment',
        type: 'select',
        options: [
          'Mountains',
          'Forest',
          'Beach',
          'Desert',
          'City Skyline',
          'Arctic',
          'Tropical',
          'Meadow',
        ],
      },
      {
        label: 'Time of Day',
        type: 'select',
        options: [
          'Day',
          'Sunrise',
          'Sunset',
          'Night',
          'Golden Hour',
          'Blue Hour',
        ],
      },
      {
        label: 'Weather',
        type: 'select',
        options: [
          'Sunny',
          'Cloudy',
          'Rainy',
          'Foggy',
          'Snowy',
          'Stormy',
          'Clear',
        ],
      },
    ],
  },

  {
    name: 'Food',
    icon: 'utensils',
    specificOptions: [
      {
        label: 'Dish Type',
        type: 'text',
      },
      {
        label: 'Presentation',
        type: 'select',
        options: [
          'Plated',
          'Street Food',
          'Fine Dining',
          'Close-up',
          'Ingredients View',
          'Appetizing',
        ],
      },
    ],
  },

  {
    name: 'Building',
    icon: 'building',
    specificOptions: [
      {
        label: 'Style',
        type: 'select',
        options: [
          'Modern',
          'Gothic',
          'Futuristic',
          'Ancient',
          'Skyscraper',
          'House',
          'Castle',
        ],
      },
    ],
  },

  {
    name: 'Fantasy',
    icon: 'hat-wizard',
    specificOptions: [
      {
        label: 'Creature/Scene',
        type: 'text',
      },
    ],
  },

  {
    name: 'Sci-Fi',
    icon: 'rocket',
    specificOptions: [
      {
        label: 'Element/Scene',
        type: 'text',
      },
    ],
  },

  {
    name: 'Nature',
    icon: 'leaf',
    specificOptions: [
      {
        label: 'Element',
        type: 'select',
        options: [
          'Flower',
          'Tree',
          'Waterfall',
          'Lake',
          'Forest',
          'Meadow',
          'River',
        ],
      },
    ],
  },

  {
    name: 'Object',
    icon: 'cube',
    specificOptions: [
      {
        label: 'Object Name',
        type: 'text',
      },
    ],
  },
];

export default categories;